import React from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Globals} from './constants';

import { Helmet } from "react-helmet";
class PlayGame extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            data: null,
            isLoading: true,
            isGamePlaying: false
        }
        console.log("params ", this.props.match.match.params.id);
        this.playGame = this.playGame.bind(this);
        let MSISDN = '';
        let GameID = this.props.match.match.params.id;
        
        MSISDN = JSON.parse(localStorage.getItem('user')).phone;
        //this.playGame();
    }
    
    async playGame() {
        let userID = JSON.parse(localStorage.getItem('user')).phone;
        let gameID = this.props.match.match.params.id;
        console.log("use game ", userID, gameID);
        this.setState({
            isGamePlaying: true
        })
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: gameID,
                msisdn: userID
            })
        };

        let resp = await fetch(`https://cwscoring.cricwick.net/api/v4/games/${gameID}/play_game?user_id=${userID}&app_name=${Globals.appName}`, requestOptions);
        let data = await resp.json();
        console.log("result ", data);


    }
    componentDidMount() {
        this.getData();
    }


    getData = async () => {
        let gameID = this.props.match.match.params.id
        const URL = `https://cwscoring.cricwick.net/api/v4/games/${gameID}?msisdn=${JSON.parse(localStorage.getItem('user')).phone}`
        let resp = await axios.get(URL)
        console.log('new resp', resp);
        this.setState({ data: resp.data, isLoading: false })

    }

    render() {

        let maxTOShow = 1;
         if(this.state.data){
             if(this.state.data.recent.length >=4){
                 maxTOShow = 4;
             }else if(this.state.data.recent.length == 0){
                 maxTOShow = 2
             }
             else if(this.state.data.recent.length == 1){
                maxTOShow = 2
            }else{
                maxTOShow = this.state.data.recent.length;
            }
         }
        var settings = {
            arrows: false,
            dots: false,
            infinite: true,
            speed: 200,
            swipeToSlide: true,
            slidesToShow: maxTOShow,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: maxTOShow,

                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: maxTOShow-1,


                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: maxTOShow-1,

                    }
                }
            ]
        };

        if (this.state.isLoading) {
            return (
                <div id="main-section">
                    <div className="card">
                      
                            <div className="main-loader card min-height-80vh">
                                <img width="64" height="64" src="/images/loader_v2.gif" alt="" />
                            </div>
                      
                    </div>
                </div>
            )
        }
        if (!this.state.isGamePlaying) {
            return (
                <section id="main-section" >
                    <Helmet>
                        <title>{this.state.data.game.title}</title>
                        <description>{this.state.data.game.description}</description>
                        <meta charset="UTF-8" />
                        <meta name="description" content={this.state.data.game.description}></meta>
                        <meta property="og:type" content="game" />
                        <meta property="og:title" content={this.state.data.game.title} />
                        <meta property="og:description" content={this.state.data.game.description} />
                        <meta property="og:image" content={this.state.data.game.custom_thumbnail} />
                        <meta property="twitter:card" content="summary_large_image" />
                    </Helmet>

                    <div className="card" ref="all" id="main-card">


                        <div className="row p-2">
                            <div className="col" style={{ 'textAlign': 'center' }}>
                                <img src={this.state.data.game.custom_thumbnail} className="img-fluid" />
                                <button onClick={this.playGame} className="play-game-button"> Play Now </button>

                            </div>

                        </div>

                        <div className="row p-2">
                            <div className="col">

                                <div style={{ 'marginTop': '50px' }}>
                                    <div className="m-auto text-center">
                                        <span className="d-inline-block t-played-text mr-4">
                                            <div className="mb-2">Played</div>
                                            <div style={{ 'fontWeight': 'bold' }}>{this.state.data.game.total_played}</div>
                                        </span>

                                        <span className="m-4 border-upward"></span>
                                        <span className="ml-4"><a target="_blank" href={"http://www.facebook.com/sharer/sharer.php?u=" + window.location.href}><img style={{ 'paddingBottom': '15px' }} src='/images/share.png' width="15px" /></a></span>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    {this.state.data.game.description}
                                </div>

                            </div>
                        </div>


                        <div className="mt-5">
                            <p className="game-cat-title-text">Recently Played</p>
                            <Slider {...settings}>
                                {
                                    this.state.data.recent.map(function (item, i) {

                                        return (
                                            <div className="text-center">

                                                {/* <Link to={`/games/${item.id}`}>  */}
                                                <a href={`/games/${item.id}`}>
                                                    <img style={{ 'margin': 'auto' }} src={item.thumbnail} width="96" height="96" />
                                                </a>
                                                <p className="text-center game-name-text"> {item.title} </p>

                                            </div>
                                        );
                                    })
                                }
                            </Slider>
                        </div>

                    </div>
                </section>
            )
        }

        return (
            <section id="main-section" >

                <Helmet>
                    <title>{this.state.data.game.title}</title>
                    <description>{this.state.data.game.description}</description>
                    <meta charset="UTF-8" />
                    <meta name="description" content={this.state.data.game.description}></meta>
                    <meta property="og:type" content="game" />
                    <meta property="og:title" content={this.state.data.game.title} />
                    <meta property="og:description" content={this.state.data.game.description} />
                    <meta property="og:image" content={this.state.data.game.custom_thumbnail} />
                    <meta property="twitter:card" content="summary_large_image" />
                </Helmet>

                <div className="card" ref="all" id="main-card" style={{width: '100%', height: this.state.data.game.height}}>

                        {/* <iframe src={this.state.data.game.url} height={this.state.data.game.height} width={this.state.data.game.width}>
                        </iframe> */}
                        <iframe src={this.state.data.game.url} style={{width: '100%', height: this.state.data.game.height}}>
                        </iframe>

                    <div className="mt-5">
                        <p className="game-cat-title-text">Recently Played</p>
                        <Slider {...settings}>
                            {
                                this.state.data.recent.map(function (item, i) {

                                    return (
                                        <div className="text-center">

                                            {/* <Link to={`/games/${item.id}`}>  */}
                                            <a  href={`/games/${item.id}`}>
                                                <img style={{ 'margin': 'auto' }} src={item.thumbnail} width="96" height="96" />
                                            </a>
                                            <p className="text-center game-name-text"> {item.title} </p>

                                        </div>
                                    );
                                })
                            }
                        </Slider>
                    </div>

                </div>
            </section>
        )
    }
}


export default PlayGame;